import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { bootstrapClarity } from './app/core/analytics/clarity.bootstrap';

// Only send to Sentry from deployed environments — localhost dev noise
// (HMR metadata swaps, vite chunk mismatches) should stay out of the dashboard.
const isLocalhost =
  typeof window !== 'undefined' &&
  /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

if (environment.sentryDsn && !isLocalhost) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.firebase.projectId,
    release: `ourmemory-webapp@${environment.appVersion}`,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    sendDefaultPii: true,
  });
}

bootstrapClarity(environment.clarityProjectId);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
